import { inject } from '@angular/core';
import {HttpInterceptorFn, HttpErrorResponse} from '@angular/common/http';
import { from, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  if (!req.url.includes('/api/')) {
    return next(req);
  }

  if (/\/auth\/(login|refresh|logout)/.test(req.url.toLowerCase())) {
    return next(req);
  }

  return from(auth.checkAndRefreshToken()).pipe(
    switchMap((tokenReady) => {
      const token = auth.getToken();

      if (!tokenReady && !token) {
        console.error('[AuthInterceptor] Token refresh failed');
        void auth.logout();
        return throwError(() => new Error('Authentication failed'));
      }

      if (token) {
        const authReq = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });
        return next(authReq);
      } else {
        return next(req);
      }
    }),
    catchError((err: any) => {
      console.error('[AuthInterceptor] Request failed:', err.status);

      if (err instanceof HttpErrorResponse && err.status === 401) {
        void auth.logout();
      }

      return throwError(() => err);
    })
  );
};